import {useEffect, useRef} from 'react';
import {Loading} from './components';
import {WhatsAppSettings} from './whatsapp-settings';
import {useHermes} from './lib/store';
import type {HermesState} from './lib/types';
import './whatsapp-dialog.css';

export function WhatsAppDialog({state, actions, sessionId, onClose}: {
  state: HermesState; actions: ReturnType<typeof useHermes>['actions']; sessionId: string | undefined; onClose: () => void;
}) {
  const dialog = useRef<HTMLDialogElement>(null);
  useEffect(() => {
    const element = dialog.current;
    if (!element || element.open) return;
    element.showModal();
    element.querySelector<HTMLHeadingElement>('.settings-description h2')?.focus({preventScroll: true});
  }, []);
  return <dialog ref={dialog} className="whatsapp-dialog" aria-label="WhatsApp pairing" onClose={onClose}
    onClick={event => {
      if (event.target !== event.currentTarget) return;
      const bounds = event.currentTarget.getBoundingClientRect();
      if (event.clientX < bounds.left || event.clientX > bounds.right || event.clientY < bounds.top || event.clientY > bounds.bottom) {
        event.currentTarget.close();
      }
    }}>
    <div className="whatsapp-dialog-toolbar"><button type="button" className="whatsapp-dialog-close" aria-label="Close WhatsApp" onClick={() => dialog.current?.close()}>
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.7" strokeLinecap="round" aria-hidden="true"><path d="m6 6 12 12M18 6 6 18"/></svg>
    </button></div>
    <div className="whatsapp-dialog-body">{!sessionId ? <Loading/>
      : <WhatsAppSettings state={state} actions={actions} surface="workspace" sessionId={sessionId}/>}</div>
  </dialog>;
}
